import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import PricingGrid from '../components/marketing/PricingGrid';
import HeroProductScroll from '../components/marketing/HeroProductScroll';
import StickyStory from '../components/marketing/StickyStory';
import AudienceCards from '../components/marketing/AudienceCards';
import QuoteMarquee from '../components/marketing/QuoteMarquee';
import { Feature } from '../components/ui/feature-section-with-bento-grid';
import { BRAND, FAQS } from '../data/siteContent';

export default function HomePage() {
  const heroVideoRef = useRef(null);

  useEffect(() => {
    const video = heroVideoRef.current;
    if (!video) return undefined;
    video.muted = true;
    const play = () => video.play().catch(() => {});
    play();
    video.addEventListener('loadeddata', play);
    return () => video.removeEventListener('loadeddata', play);
  }, []);

  return (
    <MarketingLayout>
      <section className="mk-hero mk-hero--shaped" aria-label={BRAND.name}>
        <div className="mk-hero-shape">
          <video
            ref={heroVideoRef}
            className="mk-hero-video"
            src={`${process.env.PUBLIC_URL}/media/hero-video.mp4`}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            aria-hidden="true"
            tabIndex={-1}
          />
          <div className="mk-hero-scrim" aria-hidden="true" />

          <div className="mk-hero-copy">
            <span className="mk-hero-pill">
              <span className="material-symbols-outlined">auto_awesome</span>
              AI-Powered GED
            </span>
            <h1 className="mk-hero-title">Your Path to the GED</h1>
            <p className="mk-hero-lead">Your path to the GED, with an AI tutor that studies with you.</p>
            <div className="mk-hero-cta">
              <Link to="/signup" className="mk-btn mk-btn-primary mk-btn-lg">
                Enroll
              </Link>
              <Link to="/program" className="mk-btn mk-btn-secondary mk-btn-lg">
                See the program
              </Link>
            </div>
          </div>

          <div className="mk-hero-glass">
            <div>
              <small>AI tutor</small>
              <strong>24/7</strong>
            </div>
          </div>
        </div>
      </section>

      <HeroProductScroll />
      <Feature />
      <StickyStory />
      <AudienceCards />

      <section className="mk-section" id="plans">
        <div className="mk-container">
          <div className="mk-section-head">
            <span className="mk-eyebrow">Pricing</span>
            <h2 className="mk-h2">Choose your study runway</h2>
            <p className="mk-section-lead">1, 2, or 3 months of full access.</p>
          </div>
          <PricingGrid />
        </div>
      </section>

      <QuoteMarquee />

      <section className="mk-section">
        <div className="mk-container">
          <div className="mk-section-head">
            <span className="mk-eyebrow">FAQ</span>
            <h2 className="mk-h2">Quick answers</h2>
          </div>
          <div className="mk-faq-grid">
            {FAQS.slice(0, 4).map((item) => (
              <details key={item.q} className="mk-faq-item">
                <summary>{item.q}</summary>
                <p>{item.a}</p>
              </details>
            ))}
          </div>
          <div className="mk-center-cta">
            <Link to="/faq" className="mk-btn mk-btn-secondary">
              View all FAQs
            </Link>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
